import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useTimeout } from 'usehooks-ts';
import useSignOut from '@/hooks/users/use-sign-out';
import ROUTES from '@/routes';
import { useAuthStore, useIsAuthenticated } from '@/stores/auth';
import { makePrompt } from '@/stores/prompter';

export default function useAppGuard(shouldAuth = true) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isLoggedIn = useIsAuthenticated();
  const bouncedReason = useAuthStore((s) => s.authError);

  const isGuardActive = shouldAuth && !isLoggedIn;
  const { disposeServices } = useSignOut();

  const handleSignOut = () => {
    disposeServices();
    useAuthStore.getState().stop(false);
    navigate(ROUTES.AUTH.SIGN_IN.$path());
  };

  useTimeout(handleSignOut, isGuardActive ? 6000 : null);

  useEffect(() => {
    if (isGuardActive && bouncedReason !== false) {
      makePrompt({
        key: 'bouncer',
        type: 'alert',
        resolveButtonLabel: t('common.confirm'),
        title: t(bouncedReason || 'errors.log-out'),
        promise: handleSignOut,
      }).catch(console.warn);
    }
  }, [isGuardActive, bouncedReason]);

  // useEffect(
  //   () =>
  //     useDeviceStore.subscribe(({ requireRestart }) => {
  //       if (requireRestart) {
  //         makePrompt({
  //           key: 'connection-error-refresh',
  //           resolveButtonLabel: t('common.refresh'),
  //           title: <ConnectionError />,
  //           resolveButtonType: 'informative',
  //           promise: async () => {
  //             location.reload();
  //             await wait(5_000);
  //           },
  //         }).catch(console.warn);
  //       }
  //     }),
  //   [],
  // );
}
